import Vue from 'vue';
import VueRouter from 'vue-router';
import Category from '../pages/category.vue';
import News from '../pages/news.vue';
import Main from '../pages/partner_main.vue';
import PartnerLogin from '../pages/partner_login.vue';
import GovAnnounces from '../pages/gov_announces.vue';
import GovAnnounce from '../pages/gov_announce_single.vue';
import Dashboard from '../pages/dashboard.vue';
import Vuex from '../store/store_partner.js';
import { logout } from '../plugins/login.js';
import { unlockBody } from '../plugins/tool.js';

const state = Vuex.state;
Vue.use(VueRouter);

const routes = [
  {
    path: '',
    component: Main
  },
  {
    path: '/login',
    component: PartnerLogin
  },
  {
    path: '/news',
    component: News
  },
  {
    path: '/category',
    component: Category
  },
  {
    path: '/dashboard',
    component: Dashboard
  },
  {
    path: '/gov-announces',
    component: GovAnnounces
  },
  {
    path: '/gov-announce',
    component: GovAnnounce
  }
];

const router = new VueRouter({
  routes: routes,
  mode: process.env.VUE_APP_ROUTER_MODE
});

function setDateformat() {
  Date.prototype.yyyymmdd = function() {
    var mm = this.getMonth() + 1; // getMonth() is zero-based
    var dd = this.getDate();

    return [this.getFullYear(), mm, dd].join('-');
  };
}

function checkLoginStatus() {
  const identity = localStorage.getItem('identity');
  if (identity !== 'partners' && identity !== 'government' && identity !== null)
    logout(state);
}

// eslint-disable-next-line
function addFakeData(type) {
  if (type === 'partners') {
    //partners
    localStorage.setItem(
      state.storageKeys.token,
      'bizSession-dd3ff2341a6ab051bbfe4f3f7236a916d3809c5c5af5ce3f944901ee3bec8f29'
    );
    localStorage.setItem(state.storageKeys.displayName, 'fakePartner');
    localStorage.setItem(state.storageKeys.id, 1);
    localStorage.setItem(state.storageKeys.identity, 'partners');
    localStorage.setItem(
      state.storageKeys.logoutUrl,
      'https://account.line-beta.biz/logout?code=ceZfB2_Ae-E33cziuL7P97SZ_-edr0jgjiNVyUe3igc&redirectUri=https%3A%2F%2Fpartner-fact-checker.line-beta.biz'
    );
  } else if (type === 'government') {
    //gov
    localStorage.setItem(
      state.storageKeys.token,
      'bizSession-62d31d5cd31c63058107664f7f028a68a398cbb2a225c092ae15c0fa066f3283'
    );
    localStorage.setItem(state.storageKeys.displayName, 'fakeGovernment');
    localStorage.setItem(state.storageKeys.id, 66);
    localStorage.setItem(state.storageKeys.identity, 'government');
    localStorage.setItem(
      state.storageKeys.logoutUrl,
      'https://account.line-beta.biz/logout?code=96nVfZS-QZ_aL7zQmI9bEbtBwmKqQwue8dfFmoyMBfw&redirectUri=https%3A%2F%2Fpartner-fact-checker.line-beta.biz'
    );
  } else if (type === 'TWSE') {
    //TWSE
    localStorage.setItem(
      state.storageKeys.token,
      'bizSession-337bd0206a151e01a2cd30410db70db141c69ecffe2a684bfabf6d7899c2155a'
    );
    localStorage.setItem(state.storageKeys.displayName, 'fakeTWSE');
    localStorage.setItem(state.storageKeys.id, 67); // partner id
    localStorage.setItem(state.storageKeys.identity, 'government');
    localStorage.setItem(
      state.storageKeys.logoutUrl,
      'https://account.line-beta.biz/logout?code=96nVfZS-QZ_aL7zQmI9bEbtBwmKqQwue8dfFmoyMBfw&redirectUri=https%3A%2F%2Fpartner-fact-checker.line-beta.biz'
    );
  }
}

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  unlockBody();
  setDateformat();
  checkLoginStatus();
  //addFakeData('partners')
  let identity = localStorage.getItem(state.storageKeys.identity);

  if (!localStorage.getItem(state.storageKeys.token) && to.path !== '/login') {
    next({
      path: '/login'
    });
  } else if (
    localStorage.getItem(state.storageKeys.token) &&
    to.path == '/login'
  ) {
    next({
      path: '/'
    });
  } else if (identity == 'partners' && to.path == '/gov-announces') {
    next({
      path: '/'
    });
  } else if (identity == 'government' && to.path != '/gov-announces') {
    next({
      path: '/gov-announces'
    });
  } else next();
});

export default router;
